export default __webpack_public_path__ + "static/media/Grimjaw Gloves.973ab8a3.jpg";